import { createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "backdrop",
  class: "base-dropdown__backdrop"
}
const _hoisted_2 = { class: "base-dropdown__control" }
const _hoisted_3 = {
  ref: "dropdown",
  class: "base-dropdown__dropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["base-dropdown", _ctx.additionalClasses])
  }, [
    _createElementVNode("div", _hoisted_1, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ toggleOpen: _ctx.toggleOpen })))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "dropdown")
    ], 512)
  ], 2))
}